import React, { Suspense, lazy } from 'react'
import { Switch, Route } from 'react-router-dom'
import P from '../paths'
import Register from '../components/Register'
import Product from '../components/Product'
import GuardianEmergency from '../components/GuardianEmergency'
import PersonalityProfile from '../components/PersonalityProfile'
import LanguageNationality from '../components/LanguageNationality'
import PetsChildren from '../components/PetsChildren'
import Medical from '../components/Medical'
import Arrival from '../components/Arrival'
import Departure from '../components/Departure'
import Education from '../components/Education'
import Placement from '../components/Placement'
import Complete from '../components/Complete'
import Address from '../components/Address'
import FirebaseRegisterForm from '../components/FirebaseRegisterForm'
import FirebaseAccountDetailsForm from '../components/FirebaseAccountDetailsForm'
import RegisteredRoute from '../../../shared/components/RegisteredRoute'
import AddressedRoute from '../../../shared/components/AddressedRoute'

export default (
  <Suspense fallback={<div>Loading</div>}>
    <Switch>
      <RegisteredRoute path={P.ARRIVAL_PATH} component={Arrival} />
      <RegisteredRoute path={P.COMPLETE_PATH} component={Complete} />
      <RegisteredRoute path={P.DEPARTURE_PATH} component={Departure} />
      <RegisteredRoute path={P.EDUCATION_PATH} component={Education} />
      <RegisteredRoute path={P.GUARDIAN_EMERGENCY_PATH} component={GuardianEmergency} />
      <RegisteredRoute path={P.PERSONALITY_PROFILE_PATH} component={PersonalityProfile} />
      <RegisteredRoute path={P.LANGUAGE_NATIONALITY_PATH} component={LanguageNationality} />
      <RegisteredRoute path={P.MEDICAL_PATH} component={Medical} />
      <RegisteredRoute path={P.PETS_CHILDREN_PATH} component={PetsChildren} />
      <RegisteredRoute path={P.PLACEMENT_PATH} component={Placement} />
      <RegisteredRoute path={P.PRODUCT_PATH} component={Product} />
      <AddressedRoute path={P.FIREBASE_REGISTER_PATH} component={FirebaseRegisterForm} />
      <AddressedRoute path={P.FIREBASE_ACCOUNT_DETAILS_PATH} component={FirebaseAccountDetailsForm} />
      <AddressedRoute path={P.REGISTER_PATH} component={Register} />
      <Route exact path={P.ADDRESS_PATH} component={Address} />
    </Switch>
  </Suspense>
);
